import React from 'react';
import { Router } from '@gatsbyjs/reach-router';
import PropTypes from 'prop-types';

import RegisterForm from './RegisterForm';
import DownloadPDF from './DownloadPDF';
import IneligibleState from './IneligibleState';
import ProceedWithState from './ProceedWithState';
import Resume from './Resume';
import { TipJarTool } from '../common/TipJar';
import { ShareTool } from '../common/Share';
import Confirm from './Confirm';
import IneligibleAge from './IneligibleAge';
import IneligibleCitizenship from './IneligibleCitizenship';

function Register({ initialh1, description, successPage, isEmbed }) {
  return (
    <div data-element-id='tool_register'>
      <Router>
        <RegisterForm
          path='/tools/register'
          initialh1={initialh1}
          default
          isEmbed={isEmbed}
        />
        <DownloadPDF
          path='/tools/register/download-pdf'
          successPage={successPage}
          description={description}
        />
        <IneligibleState
          path='/tools/register/ineligible-state'
          successPage={successPage}
          description={description}
        />
        <ProceedWithState path='/tools/register/proceed-with-state' />
        <ProceedWithState
          path='/tools/register/proceed-with-state-v2'
          hasRedirectGuidance
        />
        <Resume path='/tools/register/resume' />
        <TipJarTool
          path='/tools/register/donate/'
          tool='register'
          noThanksPath='/tools/register/share/'
        />
        <ShareTool
          path='/tools/register/share/'
          description={description}
          sharePath='/register-to-vote/'
        />
        <Confirm path='/tools/register/confirm' />
        <IneligibleAge path='/tools/register/ineligible-age' />
        <IneligibleCitizenship path='/tools/register/ineligible-citizenship' />
      </Router>
    </div>
  );
}

Register.propTypes = {
  initialh1: PropTypes.string,
  successPage: PropTypes.oneOf(['donate', 'share']),
  description: PropTypes.string,
  size: PropTypes.shape({
    height: PropTypes.number,
    position: PropTypes.number,
    width: PropTypes.number,
  }),
  isEmbed: PropTypes.bool,
};

Register.defaultProps = {
  initialh1: 'Register to vote or update your registration',
  successPage: 'donate',
  isEmbed: false,
};

export default Register;
